export const registerVerifyPhoneBeforeResolve = async (_toRoute, fromRoute, next) => {
  console.log(_toRoute, fromRoute)
  const token = localStorage.getItem("register_verify_sms");
    if(!token){
        return next('/login')
    }
  return next()
};
